module.exports = __webpack_public_path__ + "img/page8img3.21974ed7.png";